import { render } from "./login_code.vue?vue&type=template&id=9b31514c"
import script from "./login_code.vue?vue&type=script&lang=js"
export * from "./login_code.vue?vue&type=script&lang=js"

import "./login_code.vue?vue&type=style&index=0&id=9b31514c&lang=css"

import exportComponent from "C:\\Project\\VuePro\\ERP\\erp-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__